/**
 * Previously injected the group-mode outer property into the fields list so
 * the backend would fetch it and the frozen "Group" column could read the
 * bin label from a known row index.
 *
 * This injection is no longer needed: the backend now appends the group bin
 * label as an extra element at the end of every well-view row
 * unconditionally (at index `fields.length`), so the frontend reads it from
 * `row[selectedProperties.length]` without requiring any field injection.
 *
 * The function is kept for API compatibility but is now a no-op that returns
 * the original array unchanged.
 */
export type DataTableViewType = "group" | "well";

export function injectGroupProperty(selectedProperties: string[] | undefined): string[] {
  return selectedProperties ?? [];
}

export default injectGroupProperty;
